/* jshint esversion: 6 */
import React from 'react';
import Modal from 'app/components/common/Modal.jsx';
import CompactSubscriptionModal from 'app/components/Subscription/CompactSubscriptionModal.jsx';

class TrialEndedModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: ''
        };

        this.dismissModal = this.dismissModal.bind(this);
        this.registerSnapshotModalSeen = this.registerSnapshotModalSeen.bind(this);

    }

    componentDidMount() {
        this.props.getPlans();

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.app.loading.SUB_UPDATE === true && this.props.app.loading.SUB_UPDATE === false) {
            let errors = this.props.getApiErrors(['SUB_UPDATE']);

            if (!errors.length) {
                // subscription has been updated reload the important bits
                this.registerSnapshotModalSeen();
                this.props.getUser();
                this.props.getUserPerms();
                this.props.getRoutes();
                this.props.getSocials(true);
                this.props.closeAllModals();
            } else {
                if (errors[0].errors?.subscription?.message) {
                    this.setState({
                        error: errors[0].errors.subscription.message
                    });
                } else {
                    this.setState({
                        error: 'There was an error processing your request. Please contact support.'
                    });
                }
            }
        }

    }

    dismissModal() {
        let constants = this.props.app.config.constants;

        // if the user dismisses the modal, put them into a user pause state
        // by calling update subscription without isHammertime or firstPullFlag
        // but only really need to do this if the user doesn't have a snapshot
        this.registerSnapshotModalSeen();
        if (!this.props.user.detail.hasSnapshot) {
            this.props.updateSubscription({
                level: constants.PUB_LEVEL_1
            });
        } else {
            this.props.closeAllModals();
        }

    }

    registerSnapshotModalSeen() {
        if (this.props.user.detail.hasSnapshot && !window.sessionStorage.getItem('hasSeenSnapshotModal')) {
            window.sessionStorage.setItem('hasSeenSnapshotModal', true);
        }
    }

    render() {
        let modalContent = null,
            headlineContent = 'Your free trial has ended.',
            mainCopy = "You're now on the free plan.",
            confirmLabel = 'Restore unlimited posting',
            confirmAction = (e) => {
                e.preventDefault();
                this.props.router.navigate("/account/subscription/new");
                this.registerSnapshotModalSeen();
                this.props.closeAllModals();
            },
            cancelLabel = 'Continue with limits',
            cancelAction = (e) => {
                e.preventDefault();

                let constants = this.props.app.config.constants;

                this.props.updateSubscription({
                    level: constants.PUB_LEVEL_1,
                    firstPullFlag: this.props.app.config.constants.FIRSTPULL_SINGLE
                });
            },
            constants = this.props.app.config.constants;

        if (Object.keys(this.props.plans.details).length === 0) {
            return null;
        }

        if (this.props.user.detail.hasSnapshot) {
            cancelAction = (e) => {
               let constants = this.props.app.config.constants;
                e.preventDefault();
                this.props.clearSnapshot();
                this.props.updateSubscription({
                    level: constants.PUB_LEVEL_1
                });
            }
        }

        modalContent = (
            <CompactSubscriptionModal
                {...this.props}
                headline={headlineContent}
                mainCopy={mainCopy}
                confirmLabel={confirmLabel}
                confirmAction={confirmAction}
                cancelLabel={cancelLabel}
                cancelAction={cancelAction}
                closeAction={this.dismissModal}/>
        )

        return (
            <Modal
                content={modalContent}
                boxClass={"trial-ended-box"}
                mainClass={"trial-ended-content"} />
        );
    }
}

TrialEndedModal.displayName = "TrialEndedModal";

export default TrialEndedModal;
